<template>
  <div>
    <fjordkraft v-if="company === 'Fjordkraft'"/>
    <fortum v-if="company === 'Fortum'"/>
    <gudbrandsdal v-if="company === 'Gudbrandsdal Energi'"/>
    <hafslund v-if="company === 'Hafslund'"/>
    <ustekveikja v-if="company === 'Ustekveikja Energi'" />
    <norgesenergi v-if="company === 'NorgesEnergi'"/>
    <trondelagkraft v-if="company === 'TrøndelagKraft'"/>
    <lyse v-if="company === 'Lyse'"/>
    <los v-if="company === 'Los'"/>
    <glitre v-if="company === 'Glitre Energi'"/>
  </div>
</template>

<script>
import fjordkraft from "./fjordkraft"
import fortum from "./fortum"
import gudbrandsdal from "./gudbrandsdal"
import hafslund from "./hafslund"
import norgesenergi from "./norgesenergi"
import trondelagkraft from "./trondelagkraft"
import lyse from "./lyse"
import los from "./los"
import glitre from "./glitre";
import ustekveikja from "@/components/powerCompanies/terms/ustekveikja";

export default {
  props: {
    company: {
      type: String,
      required: true
    }
  },
  components: {
    ustekveikja,
    glitre,
    fjordkraft,
    gudbrandsdal,
    fortum,
    hafslund,
    norgesenergi,
    trondelagkraft,
    lyse,
    los
  }
}
</script>
